import React, { createContext, useState, useEffect } from "react";
const TodoContext = createContext();

function TodoProvider({ children }) {
  const [todos, setTodos] = useState(
    localStorage.getItem("todos")
      ? JSON.parse(localStorage.getItem("todos")) //if there are items in the note return them else return []
      : []
  );

  const [currentTodo, setCurrentTodo] = useState("");
  //----------------------------------------------------------------------------------
  const handleInputChange = (e) => {
    setCurrentTodo(e.target.value);
  };
  //----------------------------------------------------------------------------------

  const addTodo = () => {
    if (currentTodo.trim() !== "") {
      setTodos([
        ...todos,
        { text: currentTodo, completed: false, id: Date.now(), isBold: false,isItalic:false },
      ]);
      setCurrentTodo("");
    }
  };

  //----------------------------------------------------------------------------------

  const editTodo = (index, newText) => {
    const newTodos = [...todos]; //take a copy of todo array
    newTodos[index].text = newText; //take the input text value and change it then push it again
    //[....todos][index].text =newText
    setTodos(newTodos);
  };
  //----------------------------------------------------------------------------------

  const toggleComplete = (index) => {
    const newTodos = [...todos];
    newTodos[index].completed = !newTodos[index].completed;
    setTodos(newTodos);
  };
  //----------------------------------------------------------------------------------

  const Bold_text = (id) => {
    setTodos(todos.map((note) =>
        note.id === id ? { ...note, isBold: !note.isBold } : note
      )
    );
  };


   //----------------------------------------------------------------------------------

   const italic_text = (id) => {
    setTodos(todos.map((note) =>
        note.id === id ? { ...note, isItalic: !note.isItalic } : note
      )
    );
  };

  //----------------------------------------------------------------------------------

  const [deletedItems, setDeletedItems] = useState(() => {
    const storedItems = localStorage.getItem("deletedItems");
    return storedItems ? JSON.parse(storedItems) : [];
  });

  const deleteTodo = (id) => {
    const updatedItems = deletedItems.filter((item) => item.id !== id);
    // Update the state with the new array
    setDeletedItems(updatedItems);
    localStorage.setItem("deletedItems", JSON.stringify(updatedItems));

    // console.log(id)
  };
  //----------------------------------------------------------------------------------

  const handleDelete = (id) => {
    // Find the item to delete
    const itemToDelete = todos.find((item) => item.id === id);

    // Use filter to create a new array without the item with the specified id
    const updatedItems = todos.filter((item) => item.id !== id);

    // Update the state with the new array
    setTodos(updatedItems);

    // Store the deleted item in the deletedItems state
    setDeletedItems((prevDeletedItems) => [...prevDeletedItems, itemToDelete]);
  };

  //----------------------------------------------------------------------------------

  const [showColors,setShowColors] = useState(true);

  const TogglesColros=()=>{
    setShowColors(!showColors)
  }

  //----------------------------------------------------------------------------------

  const [Color,setColor]=useState(() => {
    // Try to get the color from localStorage; use 'black' as a default if not found
    return localStorage.getItem('Color') || 'black';
  });
  const Text_Color=(color_)=>{
    setColor(color_)
  }

  //----------------------------------------------------------------------------------

  //localstorage

  useEffect(() => {
    localStorage.setItem("todos", JSON.stringify(todos));
  }, [todos]);

  useEffect(() => {
    const todos = localStorage.getItem("todos");
    if (todos) {
      setTodos(JSON.parse(todos));
    }
  }, []);

  useEffect(() => {
    // Update localStorage whenever items change
    localStorage.setItem("deletedItems", JSON.stringify(deletedItems));
  }, [deletedItems]);

    // Use useEffect to update localStorage whenever Color changes
    useEffect(() => {
      localStorage.setItem('Color', Color);
    }, [Color]);

  //#############################################################################################
  const values = {
    handleInputChange,
    addTodo,
    deleteTodo,
    editTodo,
    toggleComplete,
    currentTodo,
    todos,
    Bold_text,
    italic_text,
    deletedItems,
    handleDelete,
    TogglesColros,
    showColors,
    Color,
    Text_Color
  };
  return <TodoContext.Provider value={values}>{children}</TodoContext.Provider>;
}

export { TodoContext, TodoProvider };
